import type { CustomFilter } from 'modules/shift_management/hooks/reducers/filter'
import type DefaultShift from 'modules/shift_management/store/internal/models/DefaultShift'
import type Holiday from 'modules/shift_management/store/internal/models/Holiday'
import type Leave from 'modules/shift_management/store/internal/models/Leave'
import type PlanningVersion from 'modules/shift_management/store/internal/models/PlanningVersion'
import type RestDay from 'modules/shift_management/store/internal/models/RestDay'
import type { RestDayPayload } from 'modules/shift_management/store/internal/models/RestDay'
import type Shift from 'modules/shift_management/store/internal/models/Shift'
import type { ShiftPayload } from 'modules/shift_management/store/internal/models/Shift'
import { ShiftPermissionsPayload } from 'modules/shift_management/store/internal/models/ShiftPermissions'
import type ShiftsRow from 'modules/shift_management/store/internal/models/ShiftsRow'
import type TemplateWeek from 'modules/shift_management/store/internal/models/TemplateWeek'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'
import type View from 'modules/shift_management/store/internal/models/View'

export const SYMBOLIC_MIXED_VALUE = -1

export type Filters = Record<string, any>

export type EmployeePermissions = { id: number; permissions: ShiftPermissionsPayload }

interface ShiftConflict {
  conflicting_leaves_ids: number[]
  conflicting_rest_days_ids: number[]
  conflicting_shifts_ids: number[]
  employee_id: number
  id: number
  start_at: string
  local_start_at: string
}

export interface StatsPayload {
  shift_conflicts: ShiftConflict[]
  has_drafts: boolean
  has_drafts_without_conflict: boolean
}

export interface StatsResponse {
  stats: StatsPayload
}

export type ExportScheduleByOpts = 'current_filters' | 'teams' | 'managers' | 'workplaces'

export interface IExportShiftsSchedule {
  exclude_drafts: boolean
  start_at: string
  end_at: string
  export_by: ExportScheduleByOpts
  employee_ids: number[]
  logic_operator: string
  custom_filters: CustomFilter[]
  team_ids?: number[] | null
  legalEntityIds?: number[] | null
}

export interface IExportYearlyBalance {
  date_from: string
  date_to: string
  teams_ids: number[]
  locations_ids: number[]
}

export interface ConflictsProps {
  id: number
  shifts_ids: number[]
  rest_days_ids: number[]
}

export interface CopyScheduleStatsResponse {
  shifts_count: number
  rest_days_count: number
  employees_count: number
}

export interface CopyScheduleResponse {
  shifts: ShiftPayload[]
  rest_days: RestDayPayload[]
}

export type {
  Leave,
  Holiday,
  Shift,
  View,
  PlanningVersion,
  ShiftsRow,
  RestDay,
  DefaultShift,
  TemplateWeek,
  UnassignedShift,
}

export type TabsType = 'saved-shifts' | 'custom-shift'
